export function getTelHref(phone?: string | null): string | null {
  const trimmed = (phone ?? '').trim()
  return trimmed ? `tel:${trimmed}` : null
}
